module.exports = __webpack_public_path__ + "static/contact-ce645301806f44074b2c704ce4787830.svg";